import React, { memo } from 'react';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Columns, Column } from '@components/Columns';
import {
  PerksTextPairing,
  PerksBox,
  PerksIconTextPairing,
  DiversityColumns,
  DiversityTopColumn,
  DiversityBottomColumn,
  DiversityText,
  DiversityBodyText,
  BadgeFlex,
  BadgeCloudImage,
} from './BeAmazing.styles';
import { useTranslation } from 'react-i18next';
import { JoykitIconVariant } from '@components/JoykitIcon';

export const BeAmazingContent: React.FC = memo(() => {
  const { t } = useTranslation('careers');
  const beAmazingData = t('beAmazing');

  return (
    <>
      <Box>
        <PerksTextPairing
          eyebrow={beAmazingData.perks.eyebrow}
          eyebrowVariant="sectionEyeBrow24"
          eyebrowColor="humanaDark4"
          eyebrowTagName="h3"
          title={beAmazingData.perks.title}
          titleVariant="hed56"
          titleColor="black"
          titleTagName="h2"
        />
      </Box>
      <Flex paddingTop={[3, 9]} flexWrap="wrap">
        <Columns multiline>
          {beAmazingData.perksBenefits.map((perksBenefit, index) => (
            <Column width={4} key={index}>
              <PerksBox paddingY={[8]}>
                <PerksIconTextPairing
                  icon={perksBenefit.icon as JoykitIconVariant}
                  iconColor="accentBlue4"
                  iconSize={40}
                  title={perksBenefit.title}
                  titleTagName="h3"
                  titleVariant="sectionEyeBrow24"
                  titleColor="neutra6"
                  body={perksBenefit.body}
                  bodyColor="neutra5"
                  bodyVariant="dek20"
                />
              </PerksBox>
            </Column>
          ))}
        </Columns>
      </Flex>
      <DiversityColumns multiline>
        <DiversityTopColumn width={'full'}>
          <DiversityText color="neutra6" variant="calloutHed40Bold" tagName="h3">
            {beAmazingData.diversity.title}
          </DiversityText>
          <DiversityBodyText color="neutra5" variant="dek20" tagName="p" marginTop={6}>
            {beAmazingData.diversity.body}
          </DiversityBodyText>
          <DiversityBodyText color="neutra5" variant="dek20" tagName="p" marginTop={6}>
            {beAmazingData.diversity.body1}
          </DiversityBodyText>
        </DiversityTopColumn>
        <DiversityBottomColumn width={'full'}>
          <BadgeFlex paddingTop={9} paddingBottom={[8, 0]} flexWrap="wrap">
            <BadgeCloudImage src="careers/diversity-block/badge1.jpg" />
            <BadgeCloudImage src="careers/diversity-block/badge2.jpg" />
          </BadgeFlex>
        </DiversityBottomColumn>
      </DiversityColumns>
    </>
  );
});
